import cx from 'classnames'
import styles from './Welcome.module.css'
import { Button } from '@/components/Button'
import { Spinner } from '@/components/Spinner'
import { ErrorBlock } from '@/components/ErrorBlock'
import { byDesign } from '@/infra/design'
import imgChatUrl from '@/assets/misc/img_chat.svg'
import WorkspaceIntercomIllustration from '@/components/SpotIllustration/WorkspaceIntercomIllustration'

export interface WelcomeProps {
  allMessagesLoaded: boolean
  loadFailed: boolean
  loadError?: unknown
  onRetry: () => unknown
  small?: boolean
  welcomeActions?: WelcomeAction[]
  corporateMode: boolean
}

export interface WelcomeAction {
  onPress: () => unknown
  label: string
}

export function Welcome({
  allMessagesLoaded,
  loadFailed,
  loadError,
  onRetry,
  small,
  welcomeActions = [],
  corporateMode,
}: WelcomeProps) {
  return (
    <div className={cx(styles.root, small && styles.small)} data-slot="welcome">
      <div className={cx(styles.box, !allMessagesLoaded && styles.hidden)}>
        <div className={styles.content} data-slot="welcome-content">
          <h4 className={styles.title}>Welcome to the chat</h4>
          <p className={styles.description}>
            This is the very beginning of this conversation.
          </p>
          <div className={styles.actions}>
            {welcomeActions.map((action, i) => (
              <div className={styles.action} key={i}>
                <Button
                  label={action.label}
                  block={small}
                  size="small"
                  variant="translucent"
                  onPress={action.onPress}
                />
              </div>
            ))}
          </div>
        </div>
        {!corporateMode && (
          <div className={styles.illustration} data-slot="welcome-illustration">
            {byDesign(
              <img src={imgChatUrl} alt="Phone with chat bubble" />,
              <WorkspaceIntercomIllustration label="Phone with chat bubble" />,
            )}
          </div>
        )}
      </div>
      {loadFailed && <ErrorBlock onRetry={onRetry} error={loadError} />}
      {!allMessagesLoaded && !loadFailed && (
        <div className={styles.loading}>
          <Spinner />
          <p className={styles.loadingMsg}>
            Loading more messages, hang tight.
          </p>
        </div>
      )}
    </div>
  )
}
